// extracted by mini-css-extract-plugin
export var closeButton = "_mf-2";
export var closeButtonIcon = "_mf-3";
export var lightboxContent = "_mf-1";
export var lightboxOverlay = "_mf-0";